























import MapyCzBasicLayer from '@/components/maps/MapyCzBasicLayer.vue';
import MapyCzOrthoPhotoLayer from '@/components/maps/MapyCzOrtophotoLayer.vue';
import {Place} from '@/components/maps/Place';
import {DivIcon, LatLngBounds, LatLngTuple} from 'leaflet';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {LControlLayers, LMap, LMarker, LPopup} from 'vue2-leaflet';

interface EstatesMarker {
    pointsToMainEstate: boolean;
    titles: string[];
    className: string;
    coordinates: LatLngTuple;
}

@Component({components: {LPopup, MapyCzBasicLayer, MapyCzOrthoPhotoLayer, LControlLayers, LMap, LMarker}})
export default class EstatesMap extends Vue {
    @Prop({type: Object, default: null})
    public readonly mainEstate: Place | null;

    @Prop({type: Array, default: () => []})
    public readonly comparedEstates: Place[];

    protected maxPopupHeight: number | null = null;

    protected get markers(): EstatesMarker[] {
        const markers: {[coordinates: string]: EstatesMarker} = {};

        this.comparedEstates.forEach(estate => {
            const key = JSON.stringify(estate.coordinates);

            if (! (key in markers)) {
                markers[key] = {
                    titles: [estate.title],
                    coordinates: estate.coordinates,
                    className: 'compared-estate-marker',
                    pointsToMainEstate: false,
                };

                return;
            }

            markers[key].titles.push(estate.title);
        });

        if (this.mainEstate === null) {
            return Object.values(markers);
        }

        const mainEstateKey = JSON.stringify(this.mainEstate.coordinates);

        if (mainEstateKey in markers) {
            const marker = markers[mainEstateKey];
            marker.className = 'main-estate-marker compared-estate-marker-border';
            marker.pointsToMainEstate = true;
        } else {
            markers[mainEstateKey] = {
                titles: [],
                coordinates: this.mainEstate.coordinates,
                className: 'main-estate-marker',
                pointsToMainEstate: true,
            };
        }

        return Object.values(markers);
    }

    protected get bounds(): LatLngBounds {
        const markers = this.markers;

        if (markers.length === 0) {
            return new LatLngBounds([51.1, 12], [48.5, 19]); // Show whole Czechia
        }

        return new LatLngBounds(markers.map(marker => marker.coordinates)).pad(0.5);
    }

    /**
     * When initialized in parent with display: none, map dimensions cannot be calculated,
     * so these need to be recalculated when map is finally visible
     */
    public visibilityChanged(isVisible: boolean): void {
        if (! isVisible) {
            return;
        }

        this.redrawMap();
    }

    public mounted() {
        this.$nextTick(() => {
            (this.$refs.container as LMap).mapObject.invalidateSize().fitBounds(this.bounds);
        });
    }

    protected createIcon(marker: EstatesMarker): DivIcon {
        const numberOfEstates = marker.pointsToMainEstate ? (marker.titles.length + 1) : marker.titles.length;
        const content = numberOfEstates === 1 ? '' : '<span>' + numberOfEstates + '</span>';

        return new DivIcon({
            className: '',
            iconAnchor: [0, 24],
            popupAnchor: [0, -36],
            html: `<span class="${marker.className}">${content}</span>`,
        });
    }

    protected updateHeight(): void {
        const container = this.$refs.container as Element;

        this.maxPopupHeight = container.clientHeight * 0.8;
    }

    private redrawMap(): void {
        const map = (this.$refs.container as LMap).mapObject;
        const oldSize = map.getSize();

        map.invalidateSize();

        if (!map.getSize().equals(oldSize)) {
            map.fitBounds(this.bounds);
        }
    }
}
